/* Maska collection grid — filters, sort, load more, per-row switch, phone drawer (2026-10-06) */
(function () {
  function initMcg(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var SID = root.dataset.section;
  var openGroups = {};
  var timer = null;

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function applyCols() {
    var d = store('mcg-cols-d') || '4', m = store('mcg-cols-m') || '2';
    root.dataset.colsD = d; root.dataset.colsM = m;
    root.querySelectorAll('[data-cols]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cols === d ? 'true' : 'false'); });
    root.querySelectorAll('[data-cols-m]').forEach(function (b) { if (b !== root) b.setAttribute('aria-pressed', b.dataset.colsM === m ? 'true' : 'false'); });
  }
  function applyGroups() {
    root.querySelectorAll('.mcg-group').forEach(function (g) {
      var on = !!openGroups[g.dataset.group];
      g.classList.toggle('is-open', on);
      var b = g.querySelector('[data-more]');
      if (b) b.textContent = on ? b.dataset.less : b.dataset.all;
    });
  }
  function tidySort() {
    root.querySelectorAll('[data-sort] option').forEach(function (o) { if (o.value === 'most-relevant' || o.value === 'relevance') o.remove(); });
  }
  function readMore() {
    var w = root.querySelector('.mcg-desc-wrap');
    if (!w) return;
    var d = w.querySelector('.mcg-desc'), b = w.querySelector('[data-readmore]');
    if (d && b && d.scrollHeight > d.clientHeight + 4) b.hidden = false;
  }
  function openFilters(on) {
    root.classList.toggle('is-filters-open', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }
  function formUrl() {
    var form = root.querySelector('.mcg-form');
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    var q = p.toString();
    return location.pathname + (q ? '?' + q : '');
  }
  function swap(doc, sel) {
    var a = root.querySelector(sel), b = doc.querySelector('#' + root.id + ' ' + sel);
    if (a && b) a.replaceWith(b);
  }
  function load(url) {
    var u = new URL(url, location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    var f = new URL(u.href); f.searchParams.set('section_id', SID);
    root.classList.add('is-loading');
    fetch(f.href, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      swap(doc, '.mcg-results');
      swap(doc, '.mcg-side-inner');
      swap(doc, '[data-mcg-total]');
      history.replaceState(null, '', u.pathname + u.search);
      applyCols(); applyGroups(); tidySort();
      root.classList.remove('is-loading');
    }).catch(function () { location.href = u.href; });
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-sort]')) {
      var h = root.querySelector('.mcg-form input[name="sort_by"]');
      if (h) h.value = t.value;
      return load(formUrl());
    }
    if (t.matches('[data-price]')) return;
    if (t.closest('.mcg-form')) load(formUrl());
  });
  root.addEventListener('input', function (e) {
    if (!e.target.matches('[data-price]')) return;
    clearTimeout(timer);
    timer = setTimeout(function () { load(formUrl()); }, 700);
  });
  root.addEventListener('submit', function (e) {
    if (!e.target.matches('.mcg-form')) return;
    e.preventDefault();
    clearTimeout(timer);
    load(formUrl());
    openFilters(false);
  });
  root.addEventListener('click', function (e) {
    var t = e.target;
    var more = t.closest('[data-more]');
    if (more) { var g = more.closest('.mcg-group'); openGroups[g.dataset.group] = !openGroups[g.dataset.group]; applyGroups(); return; }
    var cols = t.closest('[data-cols]');
    if (cols) { store('mcg-cols-d', cols.dataset.cols); applyCols(); return; }
    var colsM = t.closest('button[data-cols-m]');
    if (colsM) { store('mcg-cols-m', colsM.dataset.colsM); applyCols(); return; }
    if (t.closest('[data-open-filters]')) { openFilters(true); return; }
    if (t.closest('[data-close-filters]') && !t.closest('button[type="submit"]')) { openFilters(false); return; }
    var rm = t.closest('[data-readmore]');
    if (rm) { rm.closest('.mcg-desc-wrap').classList.add('is-open'); rm.hidden = true; return; }
    var next = t.closest('[data-next]');
    if (next) {
      e.preventDefault();
      next.setAttribute('aria-busy', 'true');
      var f = new URL(next.href, location.href); f.searchParams.set('section_id', SID);
      fetch(f.href, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('.mcg-grid');
        doc.querySelectorAll('#' + root.id + ' .mcg-grid > li').forEach(function (li) { grid.appendChild(li); });
        swap(doc, '.mcg-pager');
      }).catch(function () { location.href = next.href; });
      return;
    }
    var a = t.closest('a[data-ajax]');
    if (a) { e.preventDefault(); load(a.href); openFilters(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-filters-open')) openFilters(false); });

  applyCols();
  tidySort();
  readMore();
}
function initAll() { document.querySelectorAll('.mcg[data-section]').forEach(initMcg); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
document.addEventListener('shopify:section:load', initAll);
})();
